export const NESHAN_API_KEY = 'service.tDyHKnFkOkYeabYPKdnrZvuA4Aq4c1jFESmpf2K4'
